module.exports = __webpack_public_path__ + "static/media/logo.e292d61b.svg";